<template>
  <div>
    <condition-part
      :hasDeliveryDate="true"
      :hasEatType="true"
      :hasTradeStatusType="true"
      :hasStore="true"
      :hasCustomer="true"
      :hasEmployee="true"
      :hasTerminal="true"
      :hasFood="isDetail"
      :hasFoodKind="isDetail"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
      :reportTypes="reportTypes"
    >
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      reportTypes: ["simple", "detail"],
      reportType: "simple",
    };
  },
  computed: {
    columns() {
      if (this.reportType == "simple") {
        return [
          { name: "TerminalNumber" },
          { name: "TerminalName" },
          { name: "SalNumber" },
          { name: "TradeType" },
          { name: "BusinessDay" },
          { name: "BusinessClass" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "SalTime" },
          { name: "DeliveryTime" },
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "Receiver" },
          { name: "ReceiverPhone" },
          { name: "Discount" },
          { name: "Total" },
          { name: "AdvancedDeposit" },
          { name: "FinalPayment" },
          { name: "FinalPaymentDate" },
          { name: "Cellphone" },
          { name: "Telephone" },
          { name: "Address" },
          { name: "IsFinalPaymentPayed" },
          { name: "Memo" },
        ];
      } else {
        return [
          { name: "TerminalNumber" },
          { name: "TerminalName" },
          { name: "SalNumber" },
          { name: "TradeType" },
          { name: "BusinessDay" },
          { name: "EmployeeNumber" },
          { name: "EmployeeName" },
          { name: "SalTime" },
          { name: "CustomerNumber" },
          { name: "CustomerName" },
          { name: "Receiver" },
          { name: "ReceiverPhone" },
          { name: "SalTotal" },
          { name: "AdvancedDeposit" },
          { name: "FoodNumber" },
          { name: "FoodName" },
          { name: "Qty" },
          { name: "SalPrice" },
          { name: "Total" },
          { name: "Unit" },
          { name: "Memo" },
          { name: "DeliveryTime" },
          { name: "FinalPaymentDate" },
        ];
      }
    },
    isDetail() {
      return this.reportType == "detail";
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getSaleOrder(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSaleOrder(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSaleOrder(condition);
    },
    getItems(condition) {
      this.reportType = condition.ReportType;
      const vm = this;
      this.$api.reports.getSaleOrder(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
